<template>
  <div id="top" class="intro">
    <div class="intro__background">
      <div class="intro__background-video-container">
        <video
            ref="video"
            loop
            autoplay
            muted
            playsinline
            disablepictureinpicture
        >
          <source
              src="../assets/video/wd-siteH265.mp4"
              type='video/mp4; codecs="hev1"'
          />
          <source
              src="../assets/video/wd-siteH264.mp4"
              type='video/mp4; codecs="avc1.4d002a"'
          />
        </video>
      </div>
      <div
          class="intro__background-mask"
          :class="{ 'is-animation-activated': videoAnimationIsStarted }"
      ></div>
    </div>
    <div class="intro__front">
      <div class="intro__content">
        <div
            v-if="!textAnimationCompleted"
            class="intro__step"
            :class="{ 'is-animation-activated': textAnimationIsStarted }"
        >
          {{ currentText }}
        </div>
        <div
            v-if="textAnimationCompleted"
            class="intro__works-block"
        >
          <div
              :class="{ 'is-animation-activated': finalAnimationIsStarted }"
              class="intro__final-container"
          >
            <div class="intro__final-logo">
              <img src="../assets/svg/wd-light.svg" alt="WD Cleaning">
            </div>
            <div class="intro__final-sidebar">
              <div class="intro__final-title"><span>WD</span> Cleaning</div>
              <h1 class="intro__final-description">Клининг в Черногории</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wait } from '@/utils/functions';

export default {
  name: 'intro',
  data() {
    return {
      textAnimationIsStarted: false,
      videoAnimationIsStarted: false,
      finalAnimationIsStarted: false,
      textAnimationCompleted: false,
      stepsText: [
        'Добро пожаловать',
        'Мы занимаемся клинингом',
      ],
      activeTextIndex: 0
    }
  },
  computed: {
    currentText() {
      return this.stepsText[this.activeTextIndex]
    }
  },
  methods: {
    async startAnimation() {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await this.runTextAnimation();
          this.textAnimationCompleted = true;
          await wait(100); // waiting for rendering button
          await this.runBtnAnimation();
          resolve();
        }, 500);
        setTimeout(() => {
          this.runVideoAnimation();
        }, 2000);
      });
    },
    async runBtnAnimation() {
      this.finalAnimationIsStarted = true;
      await wait(2000);
    },
    async runTextAnimation() {
      this.textAnimationIsStarted = true;
      await wait(1500);
      this.textAnimationIsStarted = false;
      await wait(500);
      this.activeTextIndex += 1;
      // to be continued?
      return this.activeTextIndex < this.stepsText.length ? await this.runTextAnimation() : true;
    },
    async runVideoAnimation() {
      this.videoAnimationIsStarted = true;
      await wait(8000);
      return true;
    },
    onAnimationEnds() {
      this.$emit('animation-ends');
    }
  },
  mounted() {
    this.startAnimation().then(this.onAnimationEnds.bind(this));
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

@mixin stretched {
  position: absolute;
  width: 100%;
  height: 100%;
}

.intro {
  background: #000;
  height: 100vh;
  //min-height: 600px;

  &__background {
    @include stretched;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__background-mask {
    @include stretched;
    background-color: rgba(0, 0, 0, 1);
    transition: background-color 3s linear;

    &.is-animation-activated {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  &__background-video-container {
    @include stretched;
  }

  &__front {
    @include stretched;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__content {
    position: relative;
    color: white;
  }

  &__step {
    font-family: $font-primary;
    text-transform: uppercase;
    font-size: 42px;
    font-weight: 900;
    text-align: center;
    padding: 20px;
    transition: opacity 500ms ease-in-out;
    opacity: 0;

    &.is-animation-activated {
      opacity: 1;
    }
  }

  &__works-block {

  }

  &__final-container {
    display: flex;
    align-items: center;
    transition: opacity 1s ease-in-out,
    border-width 150ms cubic-bezier(.02, 1.3, .1, 5.5) 1s;
    opacity: 0;

    &.is-animation-activated {
      opacity: 1;
      border-width: 6px;
    }
  }

  &__final-logo {
    width: 104px;
  }

  &__final-sidebar {
    margin-left: 40px;
    display: flex;
    flex-direction: column;
    font-family: $font-primary;
    text-transform: uppercase;
  }

  &__final-title {
    color: $color-primary;
    font-size: 60px;
    font-weight: 900;

    span {
      background-color: $color-primary;
      color: white;
    }
  }

  &__final-description {
    display: inline-block;
    color: white;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 7px;
    margin-top: 12px;
  }
}

/* Large desktops and laptops */
@media (min-width: 1200px) {

}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {

}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {

}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .intro {
    &__content {
      margin-top: 40px;
    }

    &__final-container {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    &__step {
      font-size: 32px;
    }

    &__final-logo {
      width: 100px;
    }

    &__final-sidebar {
      margin-left: 0;
      margin-top: 30px;
    }

    &__final-title {
      font-size: 37px;
    }

    &__final-description {
      font-size: 20px;
      letter-spacing: 0.8px;
    }
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {

}

/* Iphone 5 */
@media (max-width: 320px) {

}
</style>
